import React, { useState } from "react";
import { toast } from "sonner";
import { FileDown, Share2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { downloadPdf, sharePdf } from "@/lib/pdfExport";

export function PdfToolbar({ targetRef, filename, title }) {
  const [busy, setBusy] = useState("");
  const nodes = () => Array.from(targetRef.current?.querySelectorAll(".pdf-section") || []);
  const onDownload = async () => {
    setBusy("dl");
    try { await downloadPdf(nodes(), filename, title); toast.success("PDF indirildi"); }
    catch { toast.error("PDF oluşturulamadı"); }
    finally { setBusy(""); }
  };
  const onShare = async () => {
    setBusy("sh");
    try {
      const r = await sharePdf(nodes(), filename, title);
      if (r === "shared") toast.success("Paylaşıldı");
      else if (r === "downloaded") toast.success("PDF indirildi, sayfa bağlantısı kopyalandı");
    } catch { toast.error("Paylaşılamadı"); }
    finally { setBusy(""); }
  };
  return (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" onClick={onDownload} disabled={!!busy} data-testid="pdf-download">
        {busy === "dl" ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4 mr-1.5" />}PDF İndir
      </Button>
      <Button variant="outline" size="sm" onClick={onShare} disabled={!!busy} data-testid="pdf-share">
        {busy === "sh" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Share2 className="h-4 w-4 mr-1.5" />}Paylaş
      </Button>
    </div>
  );
}
